export default "__VITE_ASSET__BM41AB_g__"